module.exports = __webpack_public_path__ + "static/img/limit-retain-modal-1.a992b6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/limit-retain-modal-1.png
// module id = 6lEp
// module chunks = 216